import * as Solvuu_job_spec_bs$SolvuuApi0 from "./solvuu_job_spec_bs.bs.js";
var read_info = Solvuu_job_spec_bs$SolvuuApi0.read_t;
var write_info = Solvuu_job_spec_bs$SolvuuApi0.write_t;
export { read_info, write_info };
/* Solvuu_job_spec_bs-SolvuuApi0 Not a pure module */